var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShanchu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ep:search"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99",
    cx: 7.75,
    cy: 7,
    r: 6.5,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 693",
    d: "M3.75 7H11.75",
    stroke: "black",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShanchu);
export default __webpack_public_path__ + "static/media/shanchu.f2fc708ef9446e71917194148e117954.svg";
export { ForwardRef as ReactComponent };